// Transition definitions
export const HEADER_TRANSITIONS = {
    transform: 'transform 0.25s ease-out',
    filter: 'filter 0.3s ease',
    none: 'none'
}

// Container pinned to the header's bottom edge. Page-level sticky bars portal into
// it so they slide with the header instead of being animated separately.
export const HEADER_STICKY_SLOT_ID = 'header-sticky-slot'

// Header show/hide styles (scroll-based slide-up behaviour). Only `transform` may
// differ between the states: taking the header out of the document flow resizes the
// page mid-scroll and browser scroll anchoring then re-fires the scroll listener.
export const HEADER_CONTENT_STYLE = {
    visible: {
        transform: 'translate3d(0, 0, 0)',
        transition: HEADER_TRANSITIONS.transform,
        pointerEvents: 'auto'
    },
    hidden: {
        transform: 'translate3d(0, -100%, 0)',
        transition: HEADER_TRANSITIONS.transform,
        pointerEvents: 'none'
    }
}

// Gradient overlays for the transparent header variants
export const HEADER_GRADIENT_MAP = {
    'white-50': 'linear-gradient(180deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0) 100%)',
    'white-30': 'linear-gradient(180deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0) 100%)',
    'black-50': 'linear-gradient(180deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0) 100%)',
    'black-30': 'linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 100%)'
}

// Forces an own compositing layer so a hovered header's backdrop-filter
// cannot bleed through from underlying overlay elements
export const HEADER_COMPOSITING_LAYER = {
    transform: 'translateZ(0)'
}

// Logo / CMS-icon CSS filters for the transparent header variants
export const HEADER_ICON_FILTER = {
    whiteVariant: {filter: 'brightness(0) invert(1)', transition: HEADER_TRANSITIONS.filter},
    darkVariant: {filter: 'brightness(0)', transition: HEADER_TRANSITIONS.filter},
    default: {transition: HEADER_TRANSITIONS.filter}
}

// Drop-shadow applied to text and logo for readability over hero images
export const HEADER_DROP_SHADOW = {
    textShadow: '0 1px 3px rgba(0,0,0,0.3)',
    filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.2))'
}

// ── CMS value → internal code mappings ────────────────────────────────────────

// Maps CMS HeaderVariation labels to the internal variant codes used by useTransparentHeader:
//   '3' = Solid White (default), '1' = Transparent White, '2' = Transparent Black
export const HEADER_VARIATION_CMS_MAP = {
    'Solid White': '3',
    'Transparent White': '1',
    'Transparent Black': '2'
}

// Maps CMS HeaderGradient labels to the HEADER_GRADIENT_MAP keys
export const HEADER_GRADIENT_CMS_MAP = {
    'None': 'none',
    'White 50%': 'white-50',
    'White 30%': 'white-30',
    'Black 50%': 'black-50',
    'Black 30%': 'black-30'
}
